module.exports = __webpack_public_path__ + "static/media/12UNCTAD17.987c6999.jpg";